import React from "react";

const Footer = () => {
  return (
    <>
      <footer style={{ padding: "20px 0" }}>
        <div className="container">
          <p style={{ margin: "0", fontSize: "14px" }}>© Dalmaf PVT 2024</p>
          <p style={{ margin: "5px 0" }}>
            <a
              href="https://dalmaf.com/Privacy-Policy"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "black", textDecoration: "none", marginRight: "10px" }}
            >
              Privacy Policy
            </a>
            |
            <a
              href="https://dalmaf.com/TermsandCondition"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "black", textDecoration: "none", marginLeft: "10px" }}
            >
              Terms
            </a>
          </p>
        </div>
        <style>
          {`
            footer a:hover {
              color: #00e5ff;
              text-decoration: underline;
            }

            @media (max-width: 768px) {
              footer {
                padding: 15px 0;
              }

              footer p {
                font-size: 12px;
              }
            }
          `}
        </style>
      </footer>
    </>
  );
};

export default Footer;
